<template>
  <div>
    <loading-overlay :visible="loading" />
    <div v-if="orderData" class="container">
      <div class="row header">
        <div class="col-xs-12" style="text-align: center;">
          <h3>Tellimus: {{ orderData.orderNumber }}</h3>
        </div>
      </div>
      <progress-bar v-model="progress" :type="progress === 100 ? 'success' : 'warning'" />
      <div v-if="orderData" class="row justify-content-center" style="margin-top: 40px">
        <div class="col col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div class="panel panel-primary" style="margin-bottom: 0;">
            <div class="panel-heading">Tellimuse info</div>
            <div class="panel-body">
              <p><strong>Klient:</strong> {{ orderData.client }}</p>
              <p v-if="orderData.object" ><strong>Objekt:</strong> {{ orderData.object }}</p>
              <p v-if="orderData.projectName" ><strong>Projekt:</strong> {{ orderData.projectName }}</p>
              <p><strong>Tellimus loodud:</strong> {{ formatDate(orderData.createdDate) }}</p>
              <p><strong>Eeldatav tarneaeg:</strong> {{ formatDate(orderData.deliveryDate) }}</p>
              <p><strong>Staatus:</strong> {{ getEEStatus(orderData.status, orderData.subStatus) }}</p>

              <caption style="margin-top: 20px">TOOTED</caption>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nimetus</th>
                    <th>Asukoht</th>
                    <th>Tehtud</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in orderData.products" :key="index">
                    <th :class="{'bg-success': product.quantity.doneAmount >= product.quantity.amount}" scope="row">{{ index + 1 }}</th>
                    <td :class="{'bg-success': product.quantity.doneAmount >= product.quantity.amount}">{{ product.name }}</td>
                    <td :class="{'bg-success': product.quantity.doneAmount >= product.quantity.amount}">{{ plasmaAsukohtHack(product.team) }}</td>
                    <td :class="{'bg-success': product.quantity.doneAmount >= product.quantity.amount}">
                      {{ product.quantity.doneAmount }}/{{
                        product.quantity.amount
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row logos">
            <div class="col col-sm-12 text-center">
              <a target="_blank" href="https://xn--virtuaalettevte-4sb.ee/">
                <img
                  :src="produxioLogo"
                  alt=""
                >
              </a>
            </div>
            <div class="col col-sm-12 text-center">
              <a target="_blank" :href="companyLink">
                <img
                id="client-logo"
                  :src="companyLogo"
                  alt=""
                >
              </a>
            </div>
            <!-- <div class="col col-sm-12 text-center" style="margin-top: 15px;" v-for="partner in partnerLogos" :key="partner.link">
              <a target="_blank" :href="partner.link">
                <img
                  :src="partner.logo"
                  alt=""
                >
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProgressBar } from "uiv";
import LoadingOverlay from './LoadingOverlay'
import dayjs from 'dayjs'
import axios from "axios";

import lapi from './../assets/companyLogos/LAPI'
import adrem from './../assets/companyLogos/ADREM'
import plasmapro from './../assets/companyLogos/PLASMAPRO'

import hardoxLogo from './../assets/partnerLogos/HARDOX'

import produxioLogo from './../assets/produxioLogo'

export default {
  name: "app",
  components: { 
    LoadingOverlay,
    ProgressBar
  },
  data() {
    return {
      loading: true,
      progress: 40,
      orderData: null,
      produxioLogo
    };
  },
  computed: {
    companyLogo () {
      switch(this.$route.name) {
        case 'lapi':
          return lapi
        case 'plasmapro':
          return plasmapro
        case 'adrem':
          return adrem
        default:
          return ''
      }
    },
    companyLink () {
      switch(this.$route.name) {
        case 'lapi':
          return 'https://www.lapimetall.ee/'
        case 'plasmapro':
          return 'https://www.plasmapro.ee/'
        default:
          return ''
      }
    },
    partnerLogos () {
      switch(this.$route.name) {
        case 'plasmapro':
          return [
            {
              logo: hardoxLogo,
              link: 'https://www.hardoxwearparts.com/'
            }
          ]
        default:
          return []
      }
    }
  },
  methods: {
    plasmaAsukohtHack (team) {
      if (team === 'Paikuse' || team === 'Sindi') {
        return 'Sindi, Pärnu mnt 50'
      } else {
        return team
      }
    },
    calculateDonePercentage() {
      const totalProducts = this.orderData.products.length;
      const completeProducts = this.orderData.products
        .map(p => p.status === "COMPLETE")
        .filter(f => f).length;
      this.progress =
        (completeProducts / totalProducts) * 100 - (this.orderData.status !==
        "COMPLETE"
          ? 0
          : 0);
      return (completeProducts / totalProducts) * 100;
    },
    formatDate (date) {
      return dayjs(date).format('DD.MM.YYYY')
    },
    getEEStatus (string, subStatus) {
      if (string === 'COMPLETE') {
        return 'Tehtud'
      } else if (string === 'ANNULLED') {
        return 'Tühistatud'
      } else if (string === 'ORDER' && subStatus && subStatus.includes('ORDER_SENT')) {
        return 'Kaup väljastatud'
      } else if (string === 'ORDER' && subStatus && subStatus.includes('ORDER_EMAIL_SENT')) {
        return 'Klient teavitatud'
      } else if (string === 'ORDER' && subStatus && subStatus.includes('ORDER_PACKED')) {
        return 'Komplekteeritud'
      } else {
        return 'Töös'
      }

      // ['OFFER_PREPARED', 'OFFER_EMAIL_SENT', 'ORDER_PACKED', 'ORDER_EMAIL_SENT', 'ORDER_SENT']
    },
  },
  async created() {
    // eslint-disable-next-line
        this.orderData = (
    await axios.get(
        `/api/order?company=${this.$route.name}&id=${this.$route.params.id}`
      )
    ).data;
    this.calculateDonePercentage();
    
    this.loading = false

  }
};
</script>
<style>
  .table.table-striped {
    margin: 0px -15px;
    max-width: calc(100% + 30px);
    width: calc(100% + 30px);
  }

  .table > thead > tr:first-child > th:first-child,
  .table > tbody > tr > th:first-child {
    padding-left: 20px;
  }

  @media (min-width: 768px) {
    .row.logos .col-sm-7 {
      text-align: right;
    }
  }

  @media (max-width: 767px) {
    .row.logos .col {
      text-align: center;
    }

    .row.logos .col-sm-7 {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
</style>
